export default __webpack_public_path__ + "static/media/WM0360.34I-43140_-25800_0.ce7ef1bb.jpg";